import {
  Dispatch,
  ReactNode,
  createContext,
  useEffect,
  useState,
  SetStateAction,
  useContext,
} from "react";

import jwt_decode from "jwt-decode";
import http from "../services/http-common";

// ==============================|| JWT CONTEXT & PROVIDER ||============================== //

const JWTContext = createContext<{
  isLoggedIn: any;
  loading: boolean;
  token: any;
  setToken: any;
}>({
  isLoggedIn: false,
  loading: true,
  token: null,
  setToken: () => {},
});

export const JWTProvider = ({ children }: { children: ReactNode }) => {
  const [token, setToken] = useState(localStorage.getItem("token"));

  const [loading, setLoading]: any = useState(true);
  const [isLoggedIn, setIsLoggedIn]: any = useState(false);

  useEffect(() => {

    setLoading(true);

    if (token) {
      const decoded: any = jwt_decode(token);
      if (decoded.exp >= Math.floor(Date.now() / 1000)) {
        setIsLoggedIn(true);
        http.defaults.headers.common.Authorization = `Bearer ${token}`;
      } else {
        setIsLoggedIn(false);
        localStorage.clear();
        delete http.defaults.headers.common["Authorization"];
      }
      http.defaults.headers.common["Content-Type"] = "application/json";
    } else {
      setIsLoggedIn(false);
    }
    setLoading(false);
  }, [token]);

  return (
    <JWTContext.Provider value={{ isLoggedIn, loading, setToken, token }}>
      {children}
    </JWTContext.Provider>
  );
};

export default JWTContext;
export const useJWT = () => useContext(JWTContext);
